<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    翰岭站<br>
站点介绍<br>
翰岭站位于深圳市龙华区梅观路南侧规划绿地和国有储备用地内，沿梅观路呈东西向布置；车站为地下二层岛式车站。车站周边基本为成熟建成区，北侧主要有武警深圳市支队福田区中队、福田公安分局警犬基地等建筑，车站南侧翰岭院（居住小区），车站东侧半山御景（居住小区），车站东侧新彩隧道匝道.预计客流以上下班通勤的乘客为主，主要集中在B出入口。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:17	00:00	6号线	3分24秒	6分20秒<br>
松岗	06:30	23:10	6号线	3分24秒	6分20秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:16	00:00	6号线	4分45秒	6分钟<br>
松岗	06:30	23:10	6号线	4分45秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:16	01:00	6号线	4分45秒	6分钟<br>
松岗	06:30	00:10	6号线	4分45秒	6分钟<br><br>
<br>
站点出口信息<br>
A1出入口:<br>
翰岭院、半山御景<br><br>
A2出入口:<br>
翰岭院、半山御景<br><br>
B出入口:<br>
翰岭实验学校，福田区看守所，武警深圳市支队福田区中队<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 翰岭地铁站<br>
60路,324路,M312路,M579路,N9路,317路,M122路,M173路,M201路,M202路,M222路,M391路,M392路,M398路,M401路,M417路,M447路,M448路,M481路,M500路,高峰37路,高快27路,高快37路,B821路,B912路<br><br>
A2出入口:<br>
公交站名： 翰岭地铁站<br>
60路,324路,M312路,M579路,N9路,317路,M122路,M173路,M201路,M202路,M222路,M391路,M392路,M398路,M401路,M417路,M447路,M448路,M481路,M500路,高峰37路,高快27路,高快37路,B821路,B912路<br><br>
B出入口:<br>
公交站名： 翰岭地铁站<br>
B821路,B912路,M579路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>